import { React, memo, Fragment, useState, useEffect } from 'react'
import {
  Alert,
  Divider,
  Button,
  Col,
  Row,
  Link,
  Dropdown,
  HeadingText,
  LoadingSpinner,
  BodyText,
  Container,
  Tooltip,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { bool, string, array } from 'prop-types'
import DARSection from './request-section'
import InfoList from '../../../config/dar-config'
import {
  DAR_SUBMIT_URL,
  DATA_DAR_ACTIVITY_DOWNLOAD_PERSONAL,
  DATA_DAR_ACTIVITY_DOWNLOAD_BUSINESS,
  DATA_DAR_ACTIVITY_DOWNLOAD_BUSINESS_NATIVE,
  DATA_DAR_ACTIVITY_DOWNLOAD_PERSONAL_NATIVE,
} from '../../../constants/constants'
import { post } from '../../../utils/ajax.js'
import {
  fptiCustomImpression,
  fptiCustomClick,
  serverData,
  hasTreatmentName,
  getTreatmentDataByName,
} from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import DARSuccess from './success'

const isBusinessAccount = () => {
  const { accountType = '' } = serverData
  return accountType === 'BUSINESS' ? true : false
}

const isOtherInfoEnabled = () => {
  return (
    !isBusinessAccount() &&
    hasTreatmentName('Trmt_Manage_Dar_OtherInfo_Section')
  )
}

const DataAccessForm = memo((props) => {
  const [isValidRequest, setIsValidRequest] = useState(props.isValidRequest)
  const [selectedItems, setSelectedItems] = useState(props.selectedItems)
  const [fileType, setFileType] = useState(props.fileType)
  const [isSelectAll, setIsSelectAll] = useState(props.isSelectAll)
  const [showSpinner, setShowSpinner] = useState(props.showSpinner)
  const [showAlert, setShowAlert] = useState(props.showAlert)
  const [showSuccess, setShowSuccess] = useState(props.showSuccess)
  const [impressionDone, setImpressionDone] = useState(false)
  const [activityDownloadLink, setActivityDownloadLink] = useState('')

  const darFpti = DATAPRIVACY_FPTI.DAR
  const darFptiCheckbox = darFpti.CHECKBOX
  const { isNative, accountType } = serverData
  const DAR_REQ_LIMIT = 10

  const scrollToView = (domelement) => {
    setTimeout(() => {
      const element = document.querySelector(domelement)
      element.scrollIntoView({
        behavior: 'smooth',
      })
    }, 0)
  }

  function handleDARSubmit(event) {
    event.preventDefault()
    const { darHistory = [] } = serverData
    let pendingdars = darHistory.filter((dar) => {
      return dar.status === 'INPROGRESS' || dar.status === 'OPEN'
    })
    let darcount = Object.keys(pendingdars).length
    if (darcount >= DAR_REQ_LIMIT) {
      setShowAlert(true)
      scrollToView('#header_request_form_modal')
      return
    }
    const fptiData = darFpti.SUBMIT_BTN
    Object.assign(fptiData, {
      field_list: (selectedItems && selectedItems.join('|')) || '',
    })
    Object.assign(fptiData, { file_frmt: fileType || '' })
    fptiCustomClick(darFpti.SUBMIT_BTN)
    // validate selected infos count if not show alert
    if (!(selectedItems && selectedItems.length > 0)) {
      setIsValidRequest(false)
      setShowAlert(true)
      scrollToView('#header_request_form_modal')
      return
    }
    setIsValidRequest(true)

    let reqparams = {
      _csrf: serverData._csrf,
      infolist: JSON.stringify(selectedItems),
      filetype: fileType,
    }
    postDARRequest(reqparams)
  }
  async function postDARRequest(reqparams) {
    setShowSpinner(true)

    let response = await post(DAR_SUBMIT_URL, reqparams)
    if (response.success) {
      setShowAlert(false)
      const { data: { redirect } = {} } = response
      if (redirect) location.href = redirect
      else setShowSuccess(true)
    } else {
      setShowSpinner(false)
      setShowAlert(true)
    }
  }
  const onFiletypeChange = (event) => {
    const value = event.target.value
    setFileType(value)
  }
  const checkSelectAll = () => {
    const infolist = document.getElementsByName('infooption')
    let count = 0
    for (let info of infolist) {
      if (info.checked) count = count + 1
    }
    setIsSelectAll(infolist.length === count ? false : true)
  }
  const handleInfoclick = (event) => {
    const value = event.target.value

    let isChecked = event.target.checked
    if (isChecked && darFptiCheckbox.link) {
      darFptiCheckbox.link.length = 0
      darFptiCheckbox.link.push(value)
      fptiCustomClick(darFptiCheckbox)
    }

    let index = selectedItems.indexOf(value)
    let selectedItemsDup = []
    Object.assign(selectedItemsDup, selectedItems)
    setSelectedItems([])
    if (index === -1) {
      selectedItemsDup.push(value)
    } else {
      selectedItemsDup.splice(index, 1)
    }

    setSelectedItems(selectedItemsDup)
    checkSelectAll()
  }

  const updateSelectedInfos = () => {
    selectedItems.splice(0, selectedItems.length)
    let infolist = document.getElementsByName('infooption')
    for (let info of infolist) {
      if (isSelectAll) selectedItems.push(info.value)
    }
    setSelectedItems(selectedItems)
    setIsSelectAll(!isSelectAll)
  }
  const handleSelectAllClick = (event) => {
    event.preventDefault()
    const fptiData = isSelectAll
      ? darFpti.SELECTALL_LNK
      : darFpti.UNSELECTALL_LNK
    fptiCustomClick(fptiData)

    setIsSelectAll(!isSelectAll)
    updateSelectedInfos()
  }
  const setDefaultSelection = (value) => {
    setIsSelectAll(value)
    updateSelectedInfos()
  }
  const handleActivityDownloadClick = () => {
    fptiCustomClick(darFpti.ACTIVITY_DOWNLOAD)
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(darFpti.IMPRESSION)

      if (isOtherInfoEnabled()) {
        let fptiData = darFpti.DAR_OTHER_INFO
        let treatmentItem = getTreatmentDataByName(
          'Trmt_Manage_Dar_OtherInfo_Section',
        )
        fptiData = {
          ...fptiData,
          xe: treatmentItem.experiment_id,
          xt: treatmentItem.treatment_id,
        }
        fptiCustomImpression(fptiData)
      }
    }

    setDefaultSelection(true)
    const params = serverData.darReqParams || {}

    if (props.redirect === 'authweb') {
      postDARRequest(params)
    }
    let { infolist, filetype } = params
    if (infolist) {
      setSelectedItems(JSON.parse(infolist || '[]'))
      setFileType(filetype)
      checkSelectAll()
    }

    //set activity download link
    let downloadLink = ''
    if (isNative) {
      downloadLink =
        accountType === 'PERSONAL'
          ? DATA_DAR_ACTIVITY_DOWNLOAD_PERSONAL_NATIVE
          : DATA_DAR_ACTIVITY_DOWNLOAD_BUSINESS_NATIVE
    } else {
      downloadLink =
        accountType === 'PERSONAL'
          ? DATA_DAR_ACTIVITY_DOWNLOAD_PERSONAL
          : DATA_DAR_ACTIVITY_DOWNLOAD_BUSINESS
    }
    setActivityDownloadLink(downloadLink)
  }, [])
  function DARContent() {
    return (
      <Container form>
        <Row>
          <Col>
            {showAlert && (
              <Alert
                theme="v2"
                className="requestForm-row"
                type="error"
                closeButton={{
                  onClick: () => {
                    setShowAlert(false)
                  },
                }}
              >
                <Message
                  id={
                    isValidRequest
                      ? 'dar.header.alert.fail'
                      : 'dar.section.submit.fail'
                  }
                />
              </Alert>
            )}
            <HeadingText id="darHeader" size="lg" className="requestForm-row">
              <Message id="dar.header.title" />
            </HeadingText>
          </Col>
        </Row>
        <Row className="requestForm-row">
          <Col>
            <BodyText>
              <Message id="dar.header.desc" />
            </BodyText>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="requestForm-header-info">
              <Message
                id="dar.header.info.link"
                link={(innerMessage) => (
                  <Link
                    href={activityDownloadLink}
                    onClick={handleActivityDownloadClick}
                    id="activity_download_link"
                    theme="v2"
                  >
                    {innerMessage}
                  </Link>
                )}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row className="requestForm-row">
              <Col xs={8} md={9}>
                <HeadingText size="sm">
                  <Message id="dar.subheader.title" />
                </HeadingText>
              </Col>
              <Col xs={4} md={3} className="text-right">
                <Button
                  tertiary
                  onClick={handleSelectAllClick}
                  id={!isSelectAll ? 'deselect_all_link' : 'select_all_link'}
                  theme="v2"
                >
                  <Message
                    id={
                      !isSelectAll
                        ? 'dar.subheader.info.deselectall'
                        : 'dar.subheader.info.selectall'
                    }
                  />
                </Button>
              </Col>
            </Row>
            <Divider theme="v2" />
            {selectedItems &&
              InfoList.map((category, index) => {
                return category.countryFeatureEnabled ? (
                  <DARSection
                    key={index}
                    {...category}
                    selectedInfos={selectedItems}
                    onSectionClick={handleInfoclick}
                  />
                ) : null
              })}

            {isOtherInfoEnabled() && (
              <Fragment>
                <Divider
                  className="ppvx_divider ppvx_divider--secondary"
                  theme="v2"
                />
                <Row
                  className="requestForm-section-row otherinfo"
                  id={'request_other_info'}
                >
                  <Col xs={10} md={11} className="">
                    <Row>
                      <Col className="otherinfo-title">
                        <BodyText strong>
                          <Message id="dar.section.otherinfo.title" />
                        </BodyText>
                        <BodyText className="leftmargin-2">
                          (<Message id="dar.section.otherinfo.notinafile" />)
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="requestForm-section-desc">
                      <Col>
                        <div>
                          <Message id="dar.section.otherinfo.desc" />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={2} md={1} className="text-right">
                    <Tooltip
                      theme="v2"
                      name="otherinfo-tooltip"
                      tooltipClassName="otherinfo-tooltip-icon"
                      description={
                        <Fragment>
                          <p>
                            <Message id="dar.section.otherinfo.tooltip.lineone" />
                          </p>
                          <p>
                            <Message id="dar.section.otherinfo.tooltip.linetwo" />
                          </p>
                        </Fragment>
                      }
                    />
                  </Col>
                </Row>
              </Fragment>
            )}

            <Row>
              <Col>
                <Row className="requestForm-row">
                  <Col xs={9}>
                    <HeadingText size="md">
                      <Message id="dar.section.filetype.title" />
                    </HeadingText>
                  </Col>
                </Row>
                <Divider theme="v2" />
                <Row className="requestForm-row" id="file_type_dd">
                  <Col md={12} lg={8}>
                    <Dropdown
                      id="fileType"
                      label={<Message id="dar.section.filetype.label" />}
                      onChange={onFiletypeChange}
                      value={fileType}
                      helperText={
                        <Message
                          id={
                            fileType === 'PDF'
                              ? 'dar.section.filetype.pdf.info'
                              : 'dar.section.filetype.json.info'
                          }
                        />
                      }
                      options={[
                        {
                          label: 'PDF',
                          value: 'PDF',
                        },
                        {
                          label: 'PDF & JSON',
                          value: 'PDF & JSON',
                        },
                        {
                          label: 'Editable format (JSON)',
                          value: 'Editable format (JSON)',
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="requestForm-submit-btn-row">
          <Col
            md={{
              span: 6,
              offset: 3,
            }}
          >
            <Button
              theme="v2"
              id="submitBtn"
              type="Submit"
              onClick={handleDARSubmit}
              className="requestForm-submit-btn-width "
            >
              <Message id="dar.section.submit.buttonlabel" />
            </Button>
          </Col>
        </Row>
      </Container>
    )
  }
  function Spinner() {
    return (
      <div className="requestForm-spinner">
        <LoadingSpinner screenReaderText="loading" size="lg" theme="v2" />
      </div>
    )
  }
  const getState = (state) => {
    const DAR_STATES = {
      HOME: <DARContent />,
      SUCCESS: <DARSuccess />,
      SPINNER: <Spinner />,
    }
    return DAR_STATES[state]
  }
  return (
    <Fragment>
      {(showSuccess && getState('SUCCESS')) ||
        (showSpinner && getState('SPINNER')) ||
        getState('HOME')}
    </Fragment>
  )
})

DataAccessForm.propTypes = {
  isValidRequest: bool,
  selectedItems: array,
  fileType: string,
  isSelectAll: bool,
  showSpinner: bool,
  showAlert: bool,
  showSuccess: bool,
}

DataAccessForm.defaultProps = {
  isValidRequest: true,
  selectedItems: [],
  fileType: 'PDF',
  isSelectAll: true,
  showSpinner: false,
  showAlert: false,
  showSuccess: false,
}

DataAccessForm.displayName = 'DataAccessForm'

export default DataAccessForm
